import React from 'react';
import ButtonComponent from 'components/button/buttonComponent';
import { useNavigate } from 'react-router-dom';
import { useGetFhirProviderbyEmailQuery } from 'graphql/generated/remote-schema-hasura';
import { useAuth } from 'auth/context/AuthContext';
import moment from 'moment';
import { MY_ACCOUNT_PROFILE } from 'utilities/routes';
import { ProfileSectionTypes } from 'app/my-account/pages/my-profile/enums';

const UpdateLisences = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { data } = useGetFhirProviderbyEmailQuery({
    skip: !user?.email,
    variables: {
      email: String(user?.email),
    },
  });

  const stateLicenses = (
    data?.getFHIRProviderbyEmail?.providers?.[0]?.SENSITIVE_credentials
      ?.stateLicenses || []
  ).map((license) => ({
    state: license?.state,
    expirationDate: license?.expirationDate,
  }));

  const hasExpiredLicencesCode = stateLicenses.some((license) =>
    moment(license.expirationDate).isBefore(moment().add(7, 'days')),
  );

  if (!!stateLicenses.length && !hasExpiredLicencesCode) {
    return null;
  }

  return (
    <div className="grid grid-cols-12 bg-white gap-2.5 items-center w-full py-4 border border-t-gray-opacity-15 px-7 desktop:px-[135px]">
      <p className="desktop:col-span-10 col-span-full text-h5 font-semibold text-neutral-800">
        Action required: Please update your info about active and valid state
        license
      </p>
      <div className="desktop:col-span-2 col-span-full">
        <ButtonComponent
          className="!text-xs font-bold !w-full"
          testID={'activate-subscription'}
          onClick={() =>
            navigate(MY_ACCOUNT_PROFILE, {
              state: {
                section: ProfileSectionTypes.NPI.toString(),
              },
            })
          }
        >
          Update license
        </ButtonComponent>
      </div>
    </div>
  );
};

export default UpdateLisences;
